import React, { useEffect, useState } from "react";
import client from "../../api";
import { notifyError } from "../../helper";
import { useParams } from "react-router-dom";

const UpdateCampaign = () => {
    const {campaignID} = useParams();
    const api = client();
    const [campaignOverview, setCampaignOverview] = useState();
    useEffect(()=>{
        const getCampaignOverview = async () => {
            try{
            const response = await api.post('/v1/campaign/preview',{
                campaign_id:campaignID
            });
            if(response.status === 200 ||response.status === 201 ){
                setCampaignOverview(response.data.campaignPreview);
            }
            } catch(error){
                console.log('error.message',error);
                if(error.status === 400) notifyError('Bad Request. Not able to fetch Campaign Overview');
            }
        }
        if(!campaignOverview) getCampaignOverview();
    });

    return(<>
        update Campaign
    </>);
}
export default UpdateCampaign;